import { fromEvent, merge } from 'rxjs';
import { map, share, startWith } from 'rxjs/operators';

import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class NetworkService {
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - isOffline$
	 **-------------------------------------------------------------------------------------
	 */
	isOffline$ = merge(fromEvent(window, 'offline'), fromEvent(window, 'online')).pipe(
		startWith({ type: 'online' }),
		map(event => {
			console.log(event);
			return event.type === 'offline';
		}),
		share()
	);
}
